import { GetAgenticLogicRuleScenariosResponseBodyType } from "@intelligems/ig-types/functions/agentic-logic/rule-scenarios/rule-scenarios";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const getAgenticLogicRuleScenarios = async (ruleId: string) => {
  const resp = await api.get<GetAgenticLogicRuleScenariosResponseBodyType>(
    `/v2/agentic-logic/rules/${ruleId}/scenarios`
  );
  return resp.data;
};

/**
 * The cart scenarios the Selection-logic tab offers as preview inputs.
 * `pending` means the server has enqueued generation for the current source
 * revision — poll until the set covers the rule's branches.
 */
export const useAgenticLogicRuleScenarios = (ruleId: string | undefined) => {
  return useQuery<GetAgenticLogicRuleScenariosResponseBodyType, Error>({
    queryKey: agenticLogicKeys.scenarios(ruleId!),
    queryFn: async () => getAgenticLogicRuleScenarios(ruleId!),
    enabled: !!ruleId,
    refetchInterval: (query) =>
      query.state.data?.status === "pending" ? 4000 : false,
  });
};
